import * as React from 'react';
import { STATE } from 'app/constants';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { ListWrapper } from './components/list-wrapper';
import { ListRenderer } from './components/list-renderer';
import { actionCreators } from './actions';
import { companyReportAdminTranslation } from '../constants';
import { CompanyReportAdminState } from '../types-store';
import { scrollToTop } from 'app/infrastructure/platform/routing';

export type CompanyReportsAdminListProps = DefaultContainerProps
  & CompanyReportAdminState
  & typeof actionCreators;

class CompanyReportsAdminListComponent extends React.PureComponent<CompanyReportsAdminListProps> {
  public static statePath: string = STATE.companyReportAdministration;

  public componentWillUnmount() {
    this.props.clearList();
  }

  public componentDidMount() {
    scrollToTop();
  }

  public render() {

    const { list, loadList, deleteCompanyReport, displayError, sharedState, translation } = this.props;

    return <ListWrapper
      displayError={displayError}
      sharedState={sharedState}
      translation={translation}>
      <ListRenderer
        listState={list}
        loadList={loadList}
        deleteCompanyReport={deleteCompanyReport}
        translation={translation}
      />
    </ListWrapper>;
  }
}

const container = containerFactory(CompanyReportsAdminListComponent, actionCreators, undefined, companyReportAdminTranslation);

export { container as CompanyReportsAdminList };
